import { useContext, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { useAuth } from "react-oidc-context";

import { NavItemType } from "../../constants";
import { SiteContext } from "../../contexts/siteContext";
import { UserDataContext } from "../../contexts/userDataContext";
import { OrgDto } from "../../types/dto";
import { getIsSysAdmin, isBlast, isRoutePermitted } from "../../utils";
import { SideNavItem } from "./sideNavItem";

export const isSameOrg = (
	blockedOrgs = [] as OrgDto[],
	selectedOrgId: string
) => !!blockedOrgs.find((org: OrgDto) => org.id === selectedOrgId);

export const isBlockedOrg = (selectedOrg) =>
	selectedOrg?.customData?.isDataNodeLibrariesEnabled === false &&
	selectedOrg?.customData?.isDataBlastCloudEnabled !== true;

export const SideNavSection = ({
	navItems,
	title,
	divider,
	setShow = console.log,
}: {
	navItems: NavItemType[];
	title: string;
	divider: boolean;
	setShow: any;
}) => {
	const { selectedOrg } = useContext(UserDataContext);
	const { selectedSite } = useContext(SiteContext);
	const { isAuthenticated } = useAuth();
	const isSysAdmin = useMemo(getIsSysAdmin, [isAuthenticated]);

	if (selectedOrg.id.length === 0) return null;

	const navItemsJSX = [];
	for (const [index, navData] of navItems.entries()) {
		if (
			isRoutePermitted(
				{
					...selectedOrg.permissions,
					...selectedSite.permissions,
				},
				navData.route.permissions,
				isSysAdmin
			) &&
			!isSameOrg(navData.blockedOrgs, selectedOrg.id) &&
			!(isBlockedOrg(selectedOrg) && isBlast) &&
			(navData.allowedOrgs === undefined ||
				isSameOrg(navData.allowedOrgs, selectedOrg.id))
		) {
			navItemsJSX.push(
				// @ts-ignore
				<SideNavItem
					key={`side-nav-item-${index}`}
					setShow={setShow}
					{...navData}
				/>
			);
		}
	}

	if (navItemsJSX.length) {
		return (
			<>
				{divider ? (
					<Dropdown.Divider className="my-1 border-black" />
				) : null}
				<span className="nav-section-title">{title}</span>
				{navItemsJSX}
			</>
		);
	}

	return null;
};
